import { defineStore } from 'pinia'

export const useRatingSkillsModalStore = defineStore('rating-skills-modal', {
    state: () => ({ 
        element: [], 
        showDocs: false,
        showChat: false,
        showChatValidators: false,
        showModal: false,
        associateDocs: false,
        showValidationHistory: false,
        txtInput: '',
        TxtInputValidators: '',
    }),

    getters: {
        ShowChatValidators: (state) => state.showChatValidators,
        ShowDocs: (state) => state.showDocs,
        ShowChat: (state) => state.showChat,
        AssociateDocs: (state) => state.associateDocs,
        Element: (state) => state.element,
        ShowModal: (state) => state.showModal,
        ShowValidationHistory: (state) => state.showValidationHistory,
        TxtInput: (state) => state.txtInput,
        TxtInputValidators: (state) => state.txtInputValidators,
        
    },

    actions: {
        OpenModalDocs(element) {
            this.element = element
            this.showModal = true
            this.SetShowDocs()
        },

        CloseModal() {
            this.element = []
            this.showModal = false
            this.txtInput = ''
            this.txtInputValidators = ''
            this.ResetTabs()
        },

        SetShowChatValidators() {
            this.ResetTabs()
            this.showChatValidators = true
        },

        SetShowChat() {
            this.ResetTabs()
            this.showChat = true
        },

        SetShowDocs() {
            this.ResetTabs()
            this.showDocs = true
        },

        SetShowValidationHistory() {
            this.ResetTabs()
            this.showValidationHistory = true
        },

        SetAssociateDocs() {
            this.ResetTabs()
            this.associateDocs = true
        },

        SetTxtInput(txt) {
            this.txtInput = txt
        },

        SetTxtInputValidators(txt) {
            this.txtInputValidators = txt
        },

        ResetTabs() {
            this.showDocs = false
            this.showChat = false
            this.showChatValidators = false
            this.associateDocs = false
            this.showValidationHistory = false
        },
    }
})
